var render = function render(){var _vm=this,_c=_vm._self._c;return _c('collapsible',{attrs:{"expanded":_vm.expanded},on:{"expanded":_vm.onExpanded}},[_c('template',{slot:"title"},[(true)?_c('div',{staticClass:"number-circle float-left",class:_vm.circleClass},[_vm._v(_vm._s(_vm.stepNumber))]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.title))])]),_c('template',{slot:"content"},[_vm._t("content")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }